import fire1 from "../config/pages/basecodeforimage/images/fire1.webp";
import discover from "../config/pages/basecodeforimage/images/discover.webp";
import paypal from "../config/pages/basecodeforimage/images/paypal.webp";
import jcb from "../config/pages/basecodeforimage/images/jcb.webp";
import master from "../config/pages/basecodeforimage/images/master.webp";
import mestro from "../config/pages/basecodeforimage/images/mestro.webp";
import visa from "../config/pages/basecodeforimage/images/visa.webp";
const PriceplanImages = {
  fire1: fire1,
  //pricepupup
  discover: discover,
  paypal: paypal,
  jcb: jcb,
  master: master,
  mestro: mestro,
  visa: visa,
};

export default PriceplanImages;
